import React from 'react';

import {
  SINGLE_CHART_OUTPUT_STEP_DATA_NAME,
  SINGLE_DATASET_INPUT_STEP_DATA_NAME,
} from 'analysis-tool/AnalysisStepDataNames';
import {findAndAssertSingleStepDataFrameId} from 'analysis-tool/data/findAndAssertStepDataFrameIds';
import {
  assertViewExists,
  getMainViewItemForView,
  getViewForViewReference,
} from 'analysis-tool/data-view/AnalysisViewUtils';
import {getTableLineageAncestorSteps} from 'pipelines/StepLineageUtils';

import RegressionStepEditor from '../charting/RegressionStepEditor';
import {AnalysisMainViewItemType, MainViewComponentProps} from './MainViewTypes';

export default function EditRegressionView({
  clientStateId,
  analysis,
  onCloseStepInitializationView,
  step: regressionStep,
}: MainViewComponentProps<AnalysisMainViewItemType.EDIT_REGRESSION>): JSX.Element {
  const inputDataFrameId = findAndAssertSingleStepDataFrameId(
    regressionStep,
    SINGLE_DATASET_INPUT_STEP_DATA_NAME,
    true
  );
  const viewSteps = getTableLineageAncestorSteps(analysis, regressionStep);

  function onCloseRegression(): void {
    const viewReference = {
      stepId: regressionStep.id,
      outputReference: {
        stepDataName: SINGLE_CHART_OUTPUT_STEP_DATA_NAME,
        rawDataIndex: 0,
      },
    };
    const view = getViewForViewReference(analysis, viewReference);
    assertViewExists(view, analysis, viewReference);
    onCloseStepInitializationView(getMainViewItemForView(view, analysis.steps));
  }

  return (
    <RegressionStepEditor
      analysis={analysis}
      viewSteps={viewSteps}
      clientStateId={clientStateId}
      inputDataFrameId={inputDataFrameId}
      onCloseRegression={onCloseRegression}
    />
  );
}
